<app-card-widget title="End Customer Credit Insurance"
  [subtitle]="subtitle$ | async" *ngIf="
{
    used: usedCreditInsuranceAmount$ | async,
    current: currentCreditInsurance$ | async,
    available: availableCreditInsuranceAmount$ | async,
    endCustomer: endCustomer$ | async
} as data">
  <mat-card-content>
    <div class="item-container" *ngIf="data.current; else noInsurance">
      <div class="item">
        <div class="label">Limit</div>
        <div class="primary">{{data.current?.amount | money }}</div>
        <div class="secondary">From {{data.current?.valid_from | date:'shortDate' }}</div>
      </div>
      <div class="item">
        <div class="label">Used</div>
        <div class="primary">{{data.used?.money | money }}</div>
        <div class="secondary">{{data.used?.count }} invoices</div>
      </div>
      <div class="item">
        <div class="label">Available</div>
        <div class="primary">{{data.available | money }}</div>
      </div>
    </div>

    <ng-template #noInsurance>
      <div class="item-container">
        <div class="item">
          <div class="label">No Insurance</div>
        </div>
      </div>
    </ng-template>

    <form [formGroup]="form" id="credit-insurance-form" (ngSubmit)="save()" novalidate>
      <table mat-table [dataSource]="data.endCustomer?.credit_insurances" *ngIf="showCreditInsurances">
        <ng-container matColumnDef="valid_from">
          <th mat-header-cell *matHeaderCellDef>From</th>
          <td mat-cell *matCellDef="let insurance">{{ insurance.valid_from | date:'shortDate' }}</td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field *ngIf="added">
              <input matInput [matDatepicker]="changedDatePicker" placeholder="Date" formControlName="valid_from"  (dateChange)="$event.value.toISOString()"/>
              <mat-datepicker-toggle matSuffix [for]="changedDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #changedDatePicker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let insurance "> {{ insurance.amount.amount | currency:'EUR' }} </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field *ngIf="added" formGroupName="amount">
              <input matInput type="number" placeholder="Amount" formControlName="amount" />
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="note">
          <th mat-header-cell *matHeaderCellDef> Note </th>
          <td mat-cell *matCellDef="let insurance "> {{ insurance.note }} </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field *ngIf="added">
              <input matInput type="text" placeholder="Note" formControlName="note" />
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let insurance ">
            <button type="button" mat-icon-button color="warn" (click)="deleteCreditInsurance(insurance)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        <ng-container *ngIf="added">
          <tr mat-footer-row *matFooterRowDef="columnsToDisplay"></tr>
        </ng-container>
      </table>
    </form>

    <mat-card-actions align="end">
      <button type="button" mat-button *ngIf="!added && !added" [disabled]="locked" (click)="add()">Add</button>
      <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving"
        form="credit-insurance-form">Save</button>
      <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>

      <button type="button" mat-button [disabled]="locked || added"
        (click)="toggleDetails()">{{ showCreditInsurances ? "Hide Details" : "Show Details" }}</button>
    </mat-card-actions>

  </mat-card-content>
</app-card-widget>
